module.exports = __webpack_public_path__ + "static/code-girls-first-logo-a539a6edac58033cbe8baf4dd22d3782.png";